import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { DEFAULT_ROWS_PER_PAGE, STARTING_TABLE_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING, UR_PHASE } from '../Utils/Constants';
const sControllerEndpoint = 'LotCreationL1';


export class UsedRentalsManagementAPI {
  params;

  constructor() {
    this.params = {};
  }

  getRULots(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, state = UR_PHASE, searchBy = '') {
    this.params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (state)
      this.params.state = state;
    if (searchBy)
      this.params.searchBy = searchBy;
    return axios.get(getBackendURL() + sControllerEndpoint + '/GetListLotL1RU', { params: this.params });
  }

}

export default UsedRentalsManagementAPI


// WEBPACK FOOTER //
// ./src/API/UsedRentalsManagementAPI.js